/** The formatting a listing description is written with; everything else is reduced to its text */
const allowedTags = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'UL', 'OL', 'LI']);

/** Dropped with everything inside them: their content is code or media, never description text */
const droppedTags = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'SVG', 'MATH', 'TEMPLATE', 'NOSCRIPT']);

/**
 * A description is shown as HTML because it is written with paragraphs and lists, but it is typed by
 * any seat of the company (or synced from a feed) and shown to colleagues and on the public listing,
 * so only the formatting survives: allowed tags without a single attribute, and text.
 */
export function sanitizeDescription(html: string): string {
  const source = new DOMParser().parseFromString(html, 'text/html').body;
  const output = document.createElement('div');

  copyAllowed(source, output);

  return output.innerHTML;
}

function copyAllowed(from: Node, to: Node): void {
  from.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      to.appendChild(document.createTextNode(node.textContent ?? ''));
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const tag = (node as Element).tagName.toUpperCase();

    if (droppedTags.has(tag)) {
      return;
    }

    if (allowedTags.has(tag)) {
      const copy = document.createElement(tag.toLowerCase());
      copyAllowed(node, copy);
      to.appendChild(copy);
      return;
    }

    copyAllowed(node, to);
  });
}
